import { useApiQueries } from "../../../hooks/useApiQuery";
import { Video } from "../../../types/Video";
import { createUrlWithQuery } from "../../../hooks/utils";

export function useFetchDeviceVideos(
    queries: { deviceId: string; time: Date }[],
) {
    const videoQueries = useApiQueries<Video[]>({
        queries: [
            ...queries.map(({ deviceId, time }) => ({
                queryKey: ["device-video", deviceId, time],
                endpoint: createUrlWithQuery(`/devices/${deviceId}/videos`, {
                    time: time.toISOString(),
                }),
            })),
        ],
    });

    return videoQueries;
}
